import api from './api';
import types from './mutation-types';

export default {
	getCommCodes_({ commit, state }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setExcelPopParam_({ commit }, { key, value }) {
		commit(types.EXCEL_POUPUP_PARAM, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getVariableManagements_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;

		return api
			.getVariableManagements({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'variableManagements',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'excelDownLoadList',
						value: data?.body.selectSamPleExcelList || []
					});
					*/
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setVariableManagement_({ commit }, param) {
		return api
			.postVariableManagement(param)
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
